"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sendEmail = exports.fetchPrismicRecommendations = exports.fetchPrismicPrograms = void 0;

var types = _interopRequireWildcard(require("./types"));

var _prismicClient = _interopRequireDefault(require("../../prismicClient"));

var _query = require("../helpers/query");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var receivePrismicRecommendations = function receivePrismicRecommendations(results) {
  return {
    type: types.RECEIVE_RECOMMENDATIONS_RESULTS,
    results: results
  };
};

var receivePrismicPrograms = function receivePrismicPrograms(results) {
  return {
    type: types.RECEIVE_PROGRAMS_RESULTS,
    results: results
  };
};

var sendingEmail = function sendingEmail() {
  return {
    type: types.SEND_EMAIL
  };
};

var receivedEmail = function receivedEmail() {
  return {
    type: types.RECEIVE_EMAIL_RESULTS
  };
};

var emailFail = function emailFail() {
  return {
    type: types.RECEIVE_EMAIL_ERROR
  };
};

var fetchPrismicRecommendations = function fetchPrismicRecommendations(siteId) {
  return function fetchPrismicRecommendations(dispatch) {
    var recommendationsClient = new _prismicClient["default"](function (results) {
      return dispatch(receivePrismicRecommendations(results));
    });
    return recommendationsClient.fetchData((0, _query.queryRecommendations)(siteId), function (results) {
      return results;
    });
  };
};

exports.fetchPrismicRecommendations = fetchPrismicRecommendations;

var fetchPrismicPrograms = function fetchPrismicRecommendations(siteId, programs) {
  return function fetchPrismicRecommendations(dispatch) {
    var programsClient = new _prismicClient["default"](function (results) {
      return dispatch(receivePrismicPrograms(results));
    });
    return programsClient.fetchData((0, _query.queryPrograms)(siteId, programs), function (results) {
      return results;
    });
  };
};

exports.fetchPrismicPrograms = fetchPrismicPrograms;

var sendEmail = function sendEmail(url, email, programs) {
  return function sendEmail(dispatch) {
    dispatch(sendingEmail());
    var options = {
      method: 'POST',
      body: JSON.stringify({
        email: email,
        programs: programs
      }),
      credentials: 'same-origin'
    };
    var errorStatus = 400;
    var responseStatus;
    return fetch(url, options).then(function (response) {
      responseStatus = response.status;
      return response.json();
    }).then(function (body) {
      if (body.error || responseStatus >= errorStatus) {
        throw Error(body.errorMessage || 'System error');
      }

      return dispatch(receivedEmail());
    })["catch"](function () {
      return dispatch(emailFail());
    });
  };
};

exports.sendEmail = sendEmail;